import { Page, Text, View, Document, StyleSheet, Font, Image, } from "@react-pdf/renderer";
import React from "react";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import Header from "../../Components/GeneratePdf/Header";
import Footer from "../../Components/GeneratePdf/Footer";

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  pagewapper: { position: "relative", height: "100%", },
  content: { display: "flex", width: "570px", alignItems: "left", },
  contenttitle: { fontFamily: "Lato", fontWeight: 700, fontSize: "18px", lineHeight: "30px", color: "#426B88", },
  wapper: { width: "567px", fontFamily: "Lato", fontWeight: 400, fontSize: "12px", lineHeight: "18px", color: "#245775", },
  mainContent: { flexGrow: 1, marginTop: "28px", },
  footer: { marginTop: "auto", },
  table: { width: "100%", },
  tableRow: { flexDirection: "row", paddingVertical: 2, alignItems: "center", },
  tableHeader: { paddingVertical: 1, fontWeight: 400, border: "0px", backgroundColor: "#245775", fontWeight: "bold", color: "white", borderTopLeftRadius: 4, borderTopRightRadius: 4, },
  headerCell: { color: "white", fontWeight: 400, paddingVertical: "5px" },
  cellQuestion: { width: "70%", fontSize: 10, color: "#394554", fontWeight: 400, },
  cellScore: { width: "7%", textAlign: "center", fontSize: 10 },
  cell: { padding: "10px", textAlign: "left", },
  rowEven: { backgroundColor: "#F1F3F3", },
  rowOdd: { backgroundColor: "#FFF", },
  redRectangle: { width: 17, height: 17, backgroundColor: "#667F96", borderRadius: "1.34px", },
  grayRectangle: { width: 17, height: 17, backgroundColor: "#667F96", borderRadius: "1.34px", },
});

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const getLastFilledIndex = (scores) => {
  for (let i = scores.length - 1; i >= 0; i--) {
    if (scores[i] === 1) return i;
  }
  return -1;
};

const renderRectangle = (score, index, scores) => {
  const lastFilledIndex = getLastFilledIndex(scores);
  return index <= lastFilledIndex ? <View style={styles.grayRectangle} /> : null;
};

const QuadrantFlowMind360 = (apiData = {}) => {
  console.log("apiData in QuadrantFlowMind360", apiData);
  const respondentName = apiData?.apiData?.fullName?.split(' ')[0] || '[First Name]';
  console.log("respondentName", respondentName)
  // Process questions to replace [First Name] with the actual respondent's name
  const processedQuestions = data.map(item => ({
    ...item,
    question: item.question.replace(/\[First Name\]/g, respondentName)
  }));

  
  return (

  <View style={styles.pagewapper}>
    <Header />
    <View style={styles.content}>
      <Text style={styles.contenttitle}>MIND 360 IN FOCUS</Text>
      <View style={styles.wapper}>
        <Text>
          This chart isolates the items related to the Mind based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </Text>
      </View>
    </View>
    <View style={styles.mainContent}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}> Mind </Text>
        {[1, 2, 3, 4].map((num) => (
          <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]} > {num} </Text>
        ))}
      </View>

      {processedQuestions.map((item, index) => (
        <View key={index} style={[ styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd, ]} >
          <Text style={[styles.cell, styles.cellQuestion]}>
            {item.question.replace(/\[First Name\]/g, respondentName)}
          </Text>
          {item.scores.map((score, idx) => (
            <View key={idx} style={[styles.cell, styles.cellScore]}>
              {renderRectangle(score, idx, item.scores)}
            </View>
          ))}
        </View>
      ))}
    </View>

    <Footer />
  </View>
  );
};

export default QuadrantFlowMind360;

const data = [
  {
    quadrant: "Mind",
    question: "When presented with a problem, [First Name] needs to understand the processes before starting.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Mind",
    question: "[First Name] makes decisions based on the policies that guide them.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Mind",
    question: "[First Name] is most fulfilled when a project works like it was planned.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Mind",
    question: "[First Name] is motivated when everything has been thoughtfully planned out.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Mind",
    question: "[First Name] needs clear responsibilities to function well in their work.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Mind",
    question: "[First Name]'s superpower is analyzing the solution to a problem.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Mind",
    question: "[First Name] finds satisfaction in developing standardized procedures.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Mind",
    question: "When working on a project, [First Name] can get stuck by overthinking everything.",
    scores: [1, 1, 0, 0],
  },
  {
    quadrant: "Mind",
    question: "[First Name] believes the right structures are essential for an effective organization.",
    scores: [1, 0, 0, 0],
  },
  {
    quadrant: "Mind",
    question: "[First Name] finds  satisfaction in developing standardized procedures.",
    scores: [1, 0, 0, 0],
  },
  {
    quadrant: "Mind",
    question: "[First Name] finds satisfaction in developing effective systems.",
    scores: [1, 0, 0, 0],
  },
];
